// ── NOTHING CACHED AS ONE IDENTITY IS DRAWN AS ANOTHER ─────────────────────────────────────────
//
// This browser keeps what the intranet told it in localStorage: the inbox, the chat bubbles, unread
// markers, the saved lists, statuses. None of it records whose it was, because until demo mode a
// browser only ever had one owner. Now an admin who enters a demo resolves as a fictional world on
// the very same browser (lib/demo/view.js), and leaves it the same way. A bubble cached as the admin
// must not appear in the demo, and a fictional one must not survive it.
//
// The page carries the identity it was built for as `data-portal-identity` on the html element (an opaque
// hash from lib/demo/identity.js; the extension's runtime sets it on its frames from the boot
// payload). This compares it with the identity the stored state was written under and,
// when they differ, clears the stored state before any other script reads it.
//
// WHAT IS KEPT is a list of UI conveniences that belong to the browser rather than to whose data is
// on it: layout and filter choices, which tours were seen. It's an allowlist on purpose: a key added
// tomorrow that holds somebody's messages is cleared by default, where a list of keys to clear would
// miss it.
//
// Loaded right after storage-keys.js in CORE_SCRIPTS (lib/layout.js), which migrates old key names
// first, and ahead of every script that reads storage. The extension's frames run the same file
// after the runtime has set their globals from /api/v1/boot.
'use strict';

(function () {
  var IDENTITY_KEY = 'portal_identity';
  var KEEP = {
    portal_identity: 1,
    portal_general_prefs: 1,
    portal_groups_prefs: 1,
    portal_latest_prefs: 1,
    portal_inbox_prefs: 1,
    portal_inbox_filter: 1,
    portal_meetings_view: 1,
    portal_files_view: 1,
    portal_community_roster_sort: 1,
    portal_saved_filter: 1,
    portal_tours_seen: 1,
    portal_agenda_closed_by_user: 1,
    portal_mp_empty: 1,
    portal_auth_gate_reload: 1,
  };
  var KEEP_PREFIXES = ['portal_fbk_'];

  function kept(key) {
    if (KEEP[key]) return true;
    for (var i = 0; i < KEEP_PREFIXES.length; i++) if (key.indexOf(KEEP_PREFIXES[i]) === 0) return true;
    return false;
  }

  function clear(storage) {
    var doomed = [];
    for (var i = 0; i < storage.length; i++) {
      var k = storage.key(i);
      if (k && k.indexOf('portal_') === 0 && !kept(k)) doomed.push(k);
    }
    doomed.forEach(function (k) { storage.removeItem(k); });
    return doomed.length;
  }

  /**
   * Clear stored state written under a different identity. Returns true when it cleared.
   * A browser that has never recorded an identity keeps what it has: that state predates this file
   * and was written by the only owner the browser had.
   */
  function check() {
    var id = document.documentElement.getAttribute('data-portal-identity');
    if (!id) return false;
    try {
      var held = window.localStorage.getItem(IDENTITY_KEY);
      if (held === id) return false;
      if (held) {
        clear(window.localStorage);
        try { clear(window.sessionStorage); } catch (e) { /* why-safe: sessionStorage can be blocked on its own */ }
      }
      window.localStorage.setItem(IDENTITY_KEY, id);
      return !!held;
    } catch (err) {
      return false; // why-safe: blocked storage holds nothing to clear
    }
  }

  var reloading = false;

  /** A live-update event saying this reader now resolves as someone else (routes/events.js). The
   *  page was built for the previous identity, so it is rebuilt; check() runs again on the way in. */
  function handle(msg) {
    if (!msg || msg.type !== 'identity_changed') return false;
    if (!reloading) {
      reloading = true;
      window.location.reload();
    }
    return true;
  }

  window.PortalIdentityGuard = { check: check, handle: handle, IDENTITY_KEY: IDENTITY_KEY };
  check();
})();
